export const TEAM_MEMBER_DETAILS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/team-members", name: "Team Members" },
  { id: "/team-members/:id", name: ":name" },
];

export const CUSTOM_SCHEDULE = "Custom Schedule";
